import {
  type IProductModel,
  type ITextComponentWithAssetsModel,
} from "@nf/common";
import dynamic from "next/dynamic";
import { useTranslation } from "next-i18next";

import LandingPageBrand from "components/LandingPage/LandingPageBrand";
import LandingPageCoverGroup from "../LandingPageCoverGroup";

import { LANDING_PAGE_COMPONENT_SUB_TYPE } from "@nf/common/src/providers/DataProvider/RedBeeMedia/constants";
import type { ILandingPageJoinUsComponent } from "../types";

import styles from "./LandingPageJoinUs.module.scss";

const LandingPageOffers = dynamic(
  () => import("components/LandingPage/LandingPageOffers")
);

const LEFT_COUNT = 5;
const RIGHT_COUNT = 6;

interface LandingPageJoinUsProps {
  component: ITextComponentWithAssetsModel;
  offers?: IProductModel[];
}

const LandingPageJoinUs = ({ component, offers }: LandingPageJoinUsProps) => {
  const { t } = useTranslation("translations");
  const { sub_type } =
    component.TextParsed as unknown as ILandingPageJoinUsComponent;

  const leftAssets = component.MediaList?.slice(0, LEFT_COUNT);
  const rightAssets = component.MediaList?.slice(
    LEFT_COUNT,
    LEFT_COUNT + RIGHT_COUNT
  );

  return (
    <div className={styles.container}>
      <div className={styles.background}>
        {leftAssets && (
          <LandingPageCoverGroup
            assets={leftAssets}
            className={styles.left}
            visible={true}
          />
        )}
        {rightAssets && (
          <LandingPageCoverGroup
            assets={rightAssets}
            className={styles.right}
            startIndex={LEFT_COUNT}
            visible={true}
          />
        )}
      </div>

      <div className={styles.content}>
        <LandingPageBrand>
          <span className={styles.title}>
            {t("web_landing_page_about_bottom_text")}
          </span>
        </LandingPageBrand>

        {sub_type === LANDING_PAGE_COMPONENT_SUB_TYPE.OFFERS && offers && (
          <LandingPageOffers offers={offers} />
        )}
      </div>
    </div>
  );
};

export default LandingPageJoinUs;
